import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserPageComponent } from './feature/user-page/user-page.component';
import { AdminPageComponent } from './feature/admin-page/admin-page.component';
import { HomepageComponent } from './feature/homepage/homepage.component';
import { ErrorPageComponent } from './feature/error-page/error-page.component';
import { PreloadComponent } from './feature/preload/preload.component';
import { PlatformLogoutComponent } from './feature/platform-logout/platform-logout.component'; 
import { AuthGuard } from './core/guards/auth.guard';
import { 
  ManageChildOrgViewComponent 
} from './feature/manage-child-org/manage-child-org-view/manage-child-org-view.component';
import { ManageChildOrgEditComponent } from './feature/manage-child-org/manage-child-org-edit/manage-child-org-edit.component';
import { ManageChildOrgCreateComponent } from './feature/manage-child-org/manage-child-org-create/manage-child-org-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: '/user-page', pathMatch: 'full' },
      { path: 'homepage', component: HomepageComponent },
      { path: 'child-org/:name/view', component: ManageChildOrgViewComponent },
      { path: 'child-org/:name/edit', component: ManageChildOrgEditComponent },
      { path: 'child-org/create', component: ManageChildOrgCreateComponent },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'user-page', component: UserPageComponent
  },
  {
    path: 'admin-page', component: AdminPageComponent
  },
  {
    path: 'error-page', component: ErrorPageComponent
  },
  {
    path: 'preload', component: PreloadComponent,
  },
  {
    path: 'platform-logout', component: PlatformLogoutComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
